<template>
  <v-main>
    <v-container fluid fill-height class="rx-background nut-4 login-container">
      <v-layout align-center justify-center>
        <rx-panel class="rounded-lg" width="480" elevation="15">
          <v-toolbar
            color="rx-background nut-3"
            dense
            flat
            class="px-2"
            height="48"
          >
            <v-toolbar-title class="rx-text-h4">
              <v-icon class="mr-1 mb-1" color="#424242" medium>mdi-ticket-confirmation</v-icon>
              <span v-show="loginStepper == 1" style="color:#666;font-weight:500;">
                {{ $t("login.lbl.login") }}</span
              >
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <slot name="append-header-right"></slot>
          </v-toolbar>
          <v-divider
            color="#aaa"
          ></v-divider>
          <div>
            <v-stepper v-model="loginStepper" flat class="rounded-lg">
              <!-- 로그인 인증 단계 START-->
              <v-stepper-step
                v-show="false"
                step="1"
                :complete="loginStepper > 1"
              >
              </v-stepper-step>
              <v-stepper-content step="1" class="py-6 px-2">
                <!-- LOGO -->
                <div class="text-center">
                  <v-avatar :height="appLogo.height" :min-width="appLogo.width" tile>
                    <v-img contain aspect-ratio :height="appLogo.height" :src="appLogo.img" />
                  </v-avatar>
                </div>
                <!-- LOGIN FORM -->
                <v-card-text>
                  <div style="margin:10px 0;">
                    <v-radio-group
                      row
                      dense
                      class="ma-0"
                      hide-details="auto"
                      v-model="loginDvn"
                    >
                      <v-radio label="KRA 로그인" value="ADMIN"></v-radio>
                      <v-radio label="사용처 로그인" value="USEPLC"></v-radio>
                    </v-radio-group>
                  </div>
                  <!-- 로그인 폼 영역 START -->
                  <ValidationObserver ref="loginFormObserver">
                    <v-form ref="loginForm" autocomplete="off" lazy-validation>
                      <rx-text-field
                        id="loginId"
                        prepend-inner-icon="$vuetify.icons.fld_login_id"
                        name="loginId"
                        :label="$t('login.lbl.login_id')"
                        type="text"
                        v-model="loginId"
                        v-on:keyup.enter="loginCheck"
                        required
                        :rules="rules.loginId"
                        :showRequiredMark="false"
                        :dense="false"
                      ></rx-text-field>
                      <rx-text-field
                        id="loginPw"
                        prepend-inner-icon="$vuetify.icons.fld_pword"
                        name="loginPw"
                        :label="$t('login.lbl.login_pw')"
                        type="password"
                        v-model="loginPw"
                        v-on:keyup.enter="loginCheck"
                        required
                        :rules="rules.loginPw"
                        :showRequiredMark="false"
                         :dense="false"
                      ></rx-text-field>
                    </v-form>
                  </ValidationObserver>
                  <!-- 로그인 폼 영역 END -->
                  <div
                    class="d-flex justify-space-between"
                    style="align-items: baseline"
                  >
                    <!-- 아이디 저장 체크박스 영역 START -->
                    <rx-switch
                      v-model="isSaveLoginId"
                      class="mt-0"
                      inset
                      dense
                      hide-details
                    >
                      <template v-slot:label>
                        <div>
                          <span class="text-caption">{{
                            $t("login.lbl.saveLoginId")
                          }}</span>
                        </div>
                      </template>
                    </rx-switch>
                    <!-- 아이디 저장 체크박스 영역 END -->
                  </div>
                </v-card-text>
                <v-card-actions class="pa-4 pt-2">
                  <rx-btn
                    @click="loginCheck"
                    color="rx-btn primary"
                    dark
                    style="width: 100%"
                    width="100%"
                    rounded
                    height="44px"
                  >
                    {{ $t("login.btn.login") }}
                  </rx-btn>
                </v-card-actions>
                <div style="display:flex;align-items: center;justify-content: center;">
                  <span style="color: gray;font-size: 13px;">문의 : 02-509-2314 (CS마케팅부)</span>
                </div>
              </v-stepper-content>
              <!-- 로그인 인증 단계 START-->
              <!-- 비밀번호 변경 권유 단계 START-->
              <v-stepper-step
                v-show="false"
                step="2"
                :complete="loginStepper > 2"
              ></v-stepper-step>
              <v-stepper-content step="2" class="pa-0">
                <rx-alert
                  :type="enforcePasswordChange ? 'info' : 'error'"
                  border="left"
                  text
                  class="pa-6 pb-0"
                >
                  <span
                    v-dompurify-html="
                      enforcePasswordChange
                        ? $t('login.lbl.change_init_password_required')
                        : $t('login.lbl.password_expired_warning', [
                            rxDateDiff(
                              new Date(),
                              new Date(authInfo.passwordChangedAt)
                            ),
                          ])
                    "
                  >
                  </span>
                </rx-alert>
                <rx-password
                  v-if="loginStepper === 2"
                  ref="rxPassword"
                  :showTitle="false"
                  class="px-4"
                  :useActions="false"
                >
                </rx-password>
                <v-divider></v-divider>
                <v-card-actions class="pa-6 pt-2">
                  <v-spacer></v-spacer>
                  <rx-btn
                    v-show="
                      enforcePasswordChange
                        ? false
                        : !expiredPolicy.enforcePasswordChange
                    "
                    @click="moveMain"
                    color="rx-background nut-2"
                    class="mx-1"
                    :loading="loading"
                    depressed
                  >
                    {{ $t("password.btn.change_next") }}
                    <v-icon right>$vuetify.icons.btn_next_page</v-icon>
                  </rx-btn>
                  <rx-btn
                    @click="changePassword"
                    color="rx-btn save"
                    :loading="loading"
                    depressed
                    dark
                  >
                    <v-icon left>$vuetify.icons.fld_check</v-icon>
                    {{ $t("password.btn.change_password") }}
                  </rx-btn>
                </v-card-actions>
              </v-stepper-content>
              <!-- 비밀번호 변경 권유 단계 END-->
            </v-stepper>
          </div>

          <rx-overlay-spinner
            absolute
            :loading="loading"
            :message="loadingMessage"
          ></rx-overlay-spinner>
        </rx-panel>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { AUTH_RST_CD, $login, $checkDuplicateLogin, $usePlcLogin } from "@/redworks/api/auth";
import { $getAuthPolicy, $getAppInfo } from "@/redworks/api/settings";
import { mapGetters } from "vuex";
import { ValidationObserver } from "vee-validate";
import rxPassword from "@/redworks/components/auth/RxPassword";
import _ from "lodash";

const loginIdStorageKey = "rx.login.isSaveLoginId";
const LocaleStorageKey = "rx.login.LatestLocaleCode";

export default {
  components: {
    ValidationObserver,
    rxPassword
  },
  props: {
    isDialog: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("auth", {
      getAuthorization: "getAuthorization",
      getInitLoginForm: "getInitLoginForm"
    }),
    appLogo() {
      let appLogo = require(`@/redworks/assets/logo.png`);

      if (
        this.appInfo &&
        this.appInfo.appLogo &&
        this.appInfo.appLogo.length > 0
      ) {
        appLogo = this.appInfo.appLogo;
      }

      // 이미지 사이즈 확인
      const img = new Image();
      const imgHeight = 96; // 기준
      let imgWidth = 96;

      img.onload = () => {};
      img.src = appLogo;

      // 이미지 비율 지키기
      imgWidth = imgWidth * img.width / img.height;

      return {
        img : appLogo,
        width: imgWidth,
        height: imgHeight,
      }
    },
  },
  data() {
    return {
      loginId: "",
      loginPw: "",
      loginDvn : "USEPLC",
      isSaveLoginId: false,
      loginStepper: 1,
      rules: {
        loginId: {
          required: true,
        },
        loginPw: {
          required: true,
        },
      },
      authInfo: {},
      expiredPolicy: {}, // 비밀번호 변경 정책
      enforcePasswordChange: false, // 초기 비밀번호 변경 강제 여부
      loading: false,
      loadingMessage: null,
      appInfo: null,
    };
  },
  methods: {
    async init() {
      // 폼 항목 초기화
      this.loginId = this.loginPw = "";
      requestAnimationFrame(() => {
        if(this.$refs.loginFormObserver) {
          this.$refs.loginFormObserver.reset();
        }
      });
      this.initLoginId();
      this.initLocale();
      // const ssoStatus = this.$route.query.ssoStatus;

      // if(ssoStatus){
      //   this.$rxSnackbar("warning", this.$t("login.msg.ssoLogin_failed"));
      // }
    },
    async getAppInfo() {
      try {
        const { data } = await $getAppInfo();
        const result = data.result;
        const appInfoJson = JSON.parse(result.configVal);

        this.appInfo = appInfoJson;
      } catch (error) {
        this.$rxSnackbar("error", this.$t("common.msg.unexpected_error"));
      }
    },
    async loginCheck() {
      // login 시도하므로 initForm 여부는 false로 전환
      this.$store.dispatch("auth/initLoginForm", false);
      // 입력값 체크
      const invalid = await this.$refs.loginFormObserver.validate();
      if (invalid) {
        // 입력값 취득
        let loginForm = {
          loginId: this.loginId,
          loginPw: this.loginDvn === 'ADMIN' ?
          this.CryptoJS.SHA256(this.loginPw).toString(this.CryptoJS.enc.Hex) :
          this.loginPw
        };
        // 로그인 아이디 로컬스토리지 저장하기
        this.saveLoginId();
        try {
          this.loading = true;
          this.loadingMessage = this.$t("common.msg.authenticating");
          // 중복 로그인 확인
          //const dupl = this.checkDuplicateLogin(loginForm);

          /* if (
            ((await dupl) === true &&
              (await this.$rxConfirm(
                "warning",
                this.$t("common.lbl.login"),
                this.$t("common.msg.login_confirm")
              ))) ||
            (await dupl) === false
          ) {
          } */
           if(this.loginDvn != "ADMIN"){
              const { data } = await $usePlcLogin(loginForm);
              // 인증 성공인 경우 토큰값 저장 후 메인페이지로 이동
              this.authInfo = data.result;
            }else{
              const { data } = await $login(loginForm);
              // 인증 성공인 경우 토큰값 저장 후 메인페이지로 이동
              this.authInfo = data.result;
            }
            this.$store.dispatch("auth/setAuthorization", this.authInfo);
            this.$i18n.locale = this.authInfo.localeCode;
            localStorage.setItem(LocaleStorageKey, this.authInfo.localeCode);
            this.moveMain();
            // 비밀번호 필수 변경 확인
            //this.checkEnforcePasswordChange();
        } catch (error) {
          this.errorResponse(error);
        } finally {
          this.loading = false;
        }
      }
    },
    async checkEnforcePasswordChange() {
      // 1. 정책 조회
      if (this.getAuthorization) {
        await this.getAuthPolicy();
        // 2. 초기화비밀번호 변경여부
        if (await this.checkEnforceInitPasswordChange()) {
          this.enforcePasswordChange = true;
          this.loginStepper = 2;
        } else if (await this.checkPasswordExpiresIn()) {
          // 3. 변경주기 지난 비밀번호 변경여부
          this.moveMain();
        } else {
          this.loginStepper = 2;
        }
      } else {
        this.loginStepper = 1;
      }
    },
    async getAuthPolicy() {
      try {
        const { data } = await $getAuthPolicy();
        const config = JSON.parse(data.result.configVal);

        // 비밀번호 정책 store에 저장
        this.$store.dispatch(
          "auth/setEnforceInitPasswordChange",
          config.init.enforcePasswordChange
        );
        this.$store.dispatch("auth/setExpiredPolicy", config.expiredPolicy);
      } catch (error) {
        this.$rxSnackbar("error", this.$t("common.msg.unexpected_error"));
      }
    },
    async checkEnforceInitPasswordChange() {
      // 1. 비밀번호 필수 변경 여부 확인 (정책)
      const enforceInitPasswordChange =
        this.$store.getters["auth/getEnforceInitPasswordChange"];
      // 2. 사용자의 초기 비밀번호 사용여부 확인 (인증정보)
      const isChangedInitPwd = this.$store.getters["auth/getIsChangedInitPwd"];
      return enforceInitPasswordChange && isChangedInitPwd;
    },
    async checkPasswordExpiresIn() {
      //1. 변경주기가 지난 비밀번호 변경 정책 취득
      this.expiredPolicy = this.$store.getters["auth/getExpiredPolicy"];
      this.authInfo.passwordChangedAt =
        this.$store.getters["auth/getPasswordChagedAt"];
      try {
        let passwordUnexpired = false;
        if (this.expiredPolicy.usable) {
          const passwordChangedAt = new Date(this.authInfo.passwordChangedAt);
          const today = new Date();
          if (
            this.expiredPolicy.passwordExpiresIn >
            this.rxDateDiff(today, passwordChangedAt)
          ) {
            passwordUnexpired = true;
          }
        } else {
          passwordUnexpired = true;
        }
        return passwordUnexpired;
      } catch {
        this.$rxSnackbar("error", this.$t("common.msg.unexpected_error"));
      }
    },
    async checkDuplicateLogin(loginForm) {
      try {
        // 중복 로그인 확인
        const { data } = await $checkDuplicateLogin(loginForm);
        return data.result;
      } catch (error) {
        this.errorResponse(error);
      }
    },
    errorResponse(error) {
      if (undefined !== error.response) {
        const status = error.response.status;

        if (status == AUTH_RST_CD.UNAUTHORIZED) {
          if (error.response.data.messageCode == "401-4") {
            this.$rxSnackbar("warning", this.$t("login.msg.account_locked"));
          } else {
            this.$rxSnackbar("warning", this.$t("login.msg.login_failed"));
          }
        } else {
          this.$rxSnackbar("error", this.$t("common.msg.unexpected_error"));
        }

        this.$nextTick(() => {
          this.init();
        });
      } else {
        this.$rxSnackbar("error", this.$t("common.msg.unexpected_error"));
      }
    },
    forgotPassword() {
      // 비밀번호 찾기 화면으로 이동
      this.$router.push(this.RX_PAGE.FIND_PWORD).catch(() => {});
    },
    saveLoginId() {
      // 아이디 저장 기능 메소드
      if (this.isSaveLoginId) {
        localStorage.setItem(loginIdStorageKey, this.loginId);
      } else {
        localStorage.removeItem(loginIdStorageKey);
      }
    },
    initLoginId() {
      // 저장한 로그인 아이디 취득하는 메소드
      const id = localStorage.getItem(loginIdStorageKey);
      if (null !== id) {
        this.loginId = id;
        this.isSaveLoginId = true;
      }
    },
    initLocale() {
      // 로그인 페이지 로케일 우선순위 사용자마지막 사용 => 브라우저 로케일 => 디폴트
      // 사용자 마지막 사용 로케일 정보
      let localeCode = localStorage.getItem(LocaleStorageKey);
      // 브라우저 로케일
      if (undefined === localeCode || null === localeCode) {
        localeCode = navigator.language.split("-")[0] || navigator.userLanguage;
      }
      this.$i18n.locale = localeCode;
    },

    async changePassword() {
      try {
        this.loading = true;
        this.loadingMessage = this.$t("common.msg.processing");
        if (await this.$refs.rxPassword.changePassword()) {
          // 비밀번호 변경 성공 시
          let newAuth = {...this.$store.state.auth.authorization};
          newAuth.isChangedInitPwd = false;
          this.$store.dispatch("auth/setAuthorization", newAuth) 

          this.initPrevAccessLogShow();

          this.$router.push(this.RX_PAGE.HOME).catch(() => {});
        }
      } finally {
        this.loading = false;
      }
    },
    async moveMain() {
      const prevLoginId = sessionStorage.getItem("prevLoginId");
      this.initPrevAccessLogShow();
      if (this.isDialog) {
        // 로그인 폼 다이얼로그에서 이전 로그인 사용자와 현 로그인 사용자가 같으면 다이얼로그 닫기
        // 그렇지 않다면 메인으로 이동
        const currentLoginId = _.get(this.getAuthorization, "loginId");
        const equalsUser = prevLoginId && prevLoginId == currentLoginId;
        if (
          this.$router.currentRoute.path != this.RX_PAGE.LOGIN &&
          equalsUser
        ) {
          this.$emit("success", true);
          return;
        } else {
          this.$emit("success", false);
        }
      }

      // 공통코드 로드 (로그인 성공 후 최초 1회만)
      /* try {
        await this.$commCode.refreshCache();
      } catch (error) {
        // 공통코드 로드 실패해도 메인화면으로 이동
        this.$rxSnackbar("error", this.$t("common.msg.unexpected_error"));
      } */

      if (
        this.$route.params.path &&
        this.$route.params.path != this.RX_PAGE.LOGIN
      ) {
        this.$router.push(this.$route.params.path).catch(() => {});
        return;
      }

      this.$router.push(this.RX_PAGE.HOME).catch(() => {});
    },
    initPrevAccessLogShow() {
      sessionStorage.removeItem("prevLoginId");
      this.$store.dispatch("auth/setIsAlertPrevLoginInfo", true);
    },
  },
  async created() {
    await this.getAppInfo();
    await this.checkEnforcePasswordChange();
    await this.init();
  },
  watch: {
    isSaveLoginId() {
      this.saveLoginId();
    },
    getInitLoginForm(value) {
      if(value) {
        this.init();
        this.loginStepper= 1;
        this.$store.dispatch("auth/initLoginForm", false);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.v-stepper__content {
  padding: 20px;
}
.login-container {
  font-family: "SUIT", "LINESeedJP", "Noto Sans KR", "Noto Sans JP", sans-serif, "Apple SD 산돌고딕 Neo";
  font-weight: 400;
}

::v-deep .v-input--selection-controls {
  margin-top: 0px;
}
::v-deep .v-input--radio-group__input{
  justify-content: center;
}
</style>
